import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { Contractor } from "../../../types/models/Contractor";
import ContractorUserListItem from "../../../../timber/components/contractorUser/ContractorUserList/ContractorUserListItem";
import CuttingListItem from "../../../../timber/components/cutting/CuttingList/CuttingListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";
import TimelineRootReport from "../../generic/report/TimelineRootReport";
import GenericRootReport, {defaultFormOptions} from "../../generic/report/GenericRootReport";
import {toString} from "../../../types/models/Contractor";
import * as Api from "../../../apis/Cutting.api.ts";
import {startOfMonth, endOfMonth} from "date-fns";
import {formatDateTimeParam} from "../../../../utils/formatDate.ts";

type IFormProps = {
    data: Contractor;
};

const ContractorTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'contractorUser');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    const { page, pageSize } = { page: 0, pageSize: 10000 }
    const { data: cuttings =
        {
            items: [],
            totalItems: 0,
            page,
            pageSize,
            numPages: 0
        },
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
        Api.useGetCuttingPresentationQuery(
            {
                list: { page, pageSize },
                filter: {
                    contractorIdRefs: [data?.id],
                },
            },
            {skip: !(['reportAll', 'reportNotShipt', 'reportShipt', 'timelineReport'].includes(tabValue))}
        )

    const now = new Date();
    const cuttingIds = cuttings.items.map(item => item.id)
    const customizeFiler = (filter: Record<string, any>): Record<string, any> =>  { return {
        ...filter,
    }}
    const reportTitle = `Contractor ${toString(data)}`
    const formOptions = {
        ...defaultFormOptions,
        showCutting: true,
    }

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="Contractor-tabs"
            >
                { session.hasPermission('', 'applications/timber/entities/ContractorUsers/list/view') &&
                    <Tab label={t`Contractor Users`} value="contractorUser"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/list/view') &&
                    <Tab label={t`Cuttings`} value="cutting"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                    <Tab label={t`Report All`} value="reportAll"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                    <Tab label={t`Report Not shipt`} value="reportNotShipt"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                    <Tab label={t`Report Shipt`} value="reportShipt"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                    <Tab label={t`Timeline Report`} value="timelineReport"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/timber/entities/ContractorUsers/list/view') &&
                <TabPanel value={tabValue} index="contractorUser" data-testid="ContractorUser-tab">
                    <ContractorUserListItem contractorId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/list/view') &&
                <TabPanel value={tabValue} index="cutting" data-testid="Cutting-tab">
                    <CuttingListItem contractorId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                <TabPanel value={tabValue} index="reportAll">
                    <GenericRootReport
                        shipmentDefined={null}
                        mainTitle={reportTitle}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                        initialState={
                         {
                             startCreate: formatDateTimeParam(startOfMonth(now)),
                             endCreate: formatDateTimeParam(endOfMonth(now)),
                         }
                        }
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                <TabPanel value={tabValue} index="reportNotShipt">
                    <GenericRootReport
                        shipmentDefined={false}
                        mainTitle={reportTitle}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                        initialState={
                            {
                                startCreate: formatDateTimeParam(startOfMonth(now)),
                                endCreate: formatDateTimeParam(endOfMonth(now)),
                            }
                        }
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                <TabPanel value={tabValue} index="reportShipt">
                    <GenericRootReport
                        shipmentDefined={true}
                        mainTitle={reportTitle}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                        initialState={
                            {

                                startCreate: formatDateTimeParam(startOfMonth(now)),
                                endCreate: formatDateTimeParam(endOfMonth(now)),
                                startShipment: formatDateTimeParam(startOfMonth(now)),
                                endShipment: formatDateTimeParam(endOfMonth(now)),
                            }
                        }
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                <TabPanel value={tabValue} index="timelineReport">
                    <TimelineRootReport
                        showCutting={true}
                        initialState={
                            {

                                startCreate: formatDateTimeParam(startOfMonth(now)),
                                endCreate: formatDateTimeParam(endOfMonth(now)),
                                startShipment: formatDateTimeParam(startOfMonth(now)),
                                endShipment: formatDateTimeParam(endOfMonth(now)),
                            }
                        }
                    />
                </TabPanel>
            }
            
        </Box>
    )
}

export default ContractorTabs;
